import { useState } from 'react';

import { useUtils } from '../../utils/useUtils';

export const useTooltip = (props, widgetName = 'Tooltip') => {
  const { svgRef, tooltipRef, children, translationData } = props;

  const { configByName, getConfig } = useUtils(props, widgetName);

  const [windowIsOpen, setWindowIsOpen] = useState(false);
  const [isOpenByKeyboard, setIsOpenByKeyboard] = useState(false);

  const hasChildren = !!children;

  const tooltipContentId = `${configByName}-tooltip-content`;

  const placement = getConfig('placement', 'top-end');
  const showArrow = getConfig('showArrow', true);
  const disableRipple = getConfig('disableRipple', true);
  const muiTypographyProps = getConfig('muiTypographyProps');
  const customSize = getConfig('customSize');
  const iconColor = getConfig('iconColor');

  const toggleWindow = (e) => {
    // Detect if triggered by keyboard: either no event (old Tooltip) or event.detail === 0 (keyboard click)
    const isOpenByKeyboard = e === undefined || e?.detail === 0;

    // after tooltip windows is closed, return focus to the tooltip icon
    if (svgRef && svgRef.current && windowIsOpen && isOpenByKeyboard) {
      svgRef.current.querySelector('svg').focus();
    }

    setWindowIsOpen(!windowIsOpen);
    setIsOpenByKeyboard(isOpenByKeyboard);
  };

  const handleClickOutside = (e) => {
    tooltipRef && tooltipRef.current && !tooltipRef.current.contains(e.target) && toggleWindow(e);
  };

  //used for the old Tooltip
  const onFocusHandler = ({ keyCode, which }) => {
    (keyCode ? keyCode : which) === 13 && toggleWindow();
  };

  const onBlurHandler = () => {
    // Close tooltip when focus moves away (for keyboard navigation accessibility & tooltips that open on click)
    if (windowIsOpen && isOpenByKeyboard) {
      setWindowIsOpen(false);
      setIsOpenByKeyboard(false);
    }
  };

  const addRemoveClickEventHandler = (_) => {
    windowIsOpen
      ? document.addEventListener('click', handleClickOutside)
      : document.removeEventListener('click', handleClickOutside);
  };

  const handleClosing = () => {
    setWindowIsOpen(false);
  };

  return {
    ...props,
    toggleWindow,
    windowIsOpen,
    isOpenByKeyboard,
    handleClickOutside,
    onFocusHandler,
    onBlurHandler,
    addRemoveClickEventHandler,
    configByName,
    handleClosing,
    showArrow,
    placement,
    disableRipple,
    hasChildren,
    muiTypographyProps,
    customSize,
    translationData,
    tooltipContentId,
    iconColor,
  };
};
